import { Injectable } from '@angular/core';

import { Observable } from 'rxjs/Observable';

import { Maintenance } from 'app/models';
import { environment } from 'environments/environment';

import { HttpService } from './http.service';

const maintenanceUrl = `${environment.apiUrl}/maintenance`;

@Injectable()
export class MaintenanceService {
  constructor(private readonly httpService: HttpService) {}

  getMaintenance(): Observable<Maintenance> {
    return this.httpService.get<Maintenance>(maintenanceUrl, this.httpService.headersWithoutCredentials());
  }

  setMaintenance(maintenance: Maintenance): Observable<any> {
    return this.httpService.post(maintenanceUrl, maintenance);
  }
}



// WEBPACK FOOTER //
// ./src/app/services/maintenance.service.ts